import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaClock, FaWhatsapp, FaTelegram } from 'react-icons/fa';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Logique de soumission du formulaire
    alert('Votre message a été envoyé avec succès !');
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/33763705088', '_blank');
  };

  const openTelegram = () => {
    window.open('https://t.me/btgconseil', '_blank');
  };

  return (
    <div className="btg-contact-dark">
      <Header />
      
      <section className="btg-contact-section-dark" id="contact">
        <div className="btg-container-dark">
          {/* En-tête de la section */}
          <div className="btg-contact-header-dark">
            <div className="btg-header-badge-contact">
              <span>Contact Expert</span>
            </div>
            <h1 className="btg-contact-main-title-dark">Contactez notre équipe</h1>
            <div className="btg-contact-subtitle-accent">Prêt à concrétiser votre projet</div>
            <p className="btg-contact-description-dark">
              Notre équipe d'experts vous accompagne dans toutes les étapes de votre projet d'études en France. 
              Réponse garantie sous 24h.
            </p>
            <div className="btg-header-decoration-contact">
              <div className="btg-decoration-line-contact"></div>
              <div className="btg-decoration-dot-contact"></div>
              <div className="btg-decoration-glow-contact"></div>
            </div>
          </div>

          <div className="btg-contact-content-dark">
            {/* Informations de contact */}
            <div className="btg-contact-info-dark">
              <h3 className="btg-contact-info-title">Nos Coordonnées</h3>
              
              <div className="btg-contact-item-dark">
                <div className="btg-contact-icon-dark">
                  <FaPhone />
                </div>
                <div className="btg-contact-details-dark">
                  <h4>Téléphone</h4>
                  <p>+33 7 63 70 50 88</p>
                  <span>Lun - Ven: 9h - 18h</span>
                </div>
              </div>

              <div className="btg-contact-item-dark">
                <div className="btg-contact-icon-dark">
                  <FaEnvelope />
                </div>
                <div className="btg-contact-details-dark">
                  <h4>Email</h4>
                  <p>contact@btg-conseil.com</p>
                  <span>Réponse sous 24h</span>
                </div>
              </div>

              <div className="btg-contact-item-dark">
                <div className="btg-contact-icon-dark">
                  <FaMapMarkerAlt />
                </div>
                <div className="btg-contact-details-dark">
                  <h4>Adresse</h4>
                  <p>Paris, France</p>
                  <span>Consultations sur rendez-vous</span>
                </div>
              </div>

              <div className="btg-contact-item-dark">
                <div className="btg-contact-icon-dark">
                  <FaClock />
                </div>
                <div className="btg-contact-details-dark">
                  <h4>Horaires</h4>
                  <p>Lundi - Vendredi</p>
                  <span>9h00 - 18h00</span>
                </div>
              </div>

              {/* Boutons de contact rapide */}
              <div className="btg-quick-contact-dark">
                <h4 className="btg-quick-contact-title">Contact Rapide</h4>
                <div className="btg-quick-buttons-dark">
                  <button className="btg-whatsapp-btn-dark" onClick={openWhatsApp}>
                    <FaWhatsapp className="btg-quick-icon" />
                    <span>WhatsApp</span>
                  </button>
                  <button className="btg-telegram-btn-dark" onClick={openTelegram}>
                    <FaTelegram className="btg-quick-icon" />
                    <span>Telegram</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Formulaire de contact */}
            <div className="btg-contact-form-dark">
              <div className="btg-form-header-dark">
                <h3 className="btg-form-title-dark">Envoyez-nous un message</h3>
                <p className="btg-form-subtitle-dark">Remplissez le formulaire ci-dessous</p>
              </div>
              
              <form onSubmit={handleSubmit} className="btg-contact-form-main">
                <div className="btg-form-group-dark">
                  <label htmlFor="name" className="btg-form-label-dark">Nom Complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Votre nom complet"
                    className="btg-form-input-dark"
                  />
                </div>

                <div className="btg-form-group-dark">
                  <label htmlFor="email" className="btg-form-label-dark">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="votre@email.com"
                    className="btg-form-input-dark"
                  />
                </div>

                <div className="btg-form-group-dark">
                  <label htmlFor="phone" className="btg-form-label-dark">Téléphone</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    placeholder="+33 XX XX XX XX"
                    className="btg-form-input-dark"
                  />
                </div>

                <div className="btg-form-group-dark">
                  <label htmlFor="subject" className="btg-form-label-dark">Sujet *</label>
                  <select id="subject" name="subject" required className="btg-form-select-dark">
                    <option value="">Choisissez un sujet</option>
                    <option value="admission">Admission en France</option>
                    <option value="visa">Demande de Visa</option>
                    <option value="logement">Recherche de Logement</option>
                    <option value="information">Information Générale</option>
                    <option value="other">Autre</option>
                  </select>
                </div>

                <div className="btg-form-group-dark">
                  <label htmlFor="message" className="btg-form-label-dark">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="6"
                    required
                    placeholder="Décrivez votre projet d'études en France..."
                    className="btg-form-textarea-dark"
                  ></textarea>
                </div>

                <button type="submit" className="btg-submit-btn-dark">
                  <span>Envoyer le Message</span>
                  <FaWhatsapp className="btg-submit-icon-dark" />
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Éléments de fond décoratifs */}
        <div className="btg-contact-background-elements">
          <div className="btg-contact-bg-element btg-contact-bg-1"></div>
          <div className="btg-contact-bg-element btg-contact-bg-2"></div>
          <div className="btg-contact-bg-element btg-contact-bg-3"></div>
          <div className="btg-contact-bg-element btg-contact-bg-4"></div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;